import { render, staticRenderFns } from "./SecurityTabs.vue?vue&type=template&id=480d8dc2&scoped=true"
import script from "./SecurityTabs.vue?vue&type=script&lang=js"
export * from "./SecurityTabs.vue?vue&type=script&lang=js"
import style0 from "./SecurityTabs.vue?vue&type=style&index=0&id=480d8dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d8dc2",
  null
  
)

export default component.exports